import Model from 'src/storage/base';
import { validateObj } from 'src/helpers';

class CertificateModel extends Model {
  id = 'CertificateModel';
  defaultState = () => ({
    updating: false,
    certificateFiles: [],
    updatingData: []
  });
  persistent = false;
  apiConfig = {
    update: {
      url: 'profile/set/certificateFile',
      validation: {
        certificateFiles: 'certificateFiles2'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile'
  };

  handleProfile = (profile) => {
    const certificateFiles = JSON.parse(JSON.stringify(profile.certificateFiles || []));
    const currentCertificateFiles = Array.isArray(this.state.certificateFiles)
      ? this.state.certificateFiles
      : [];

    this.setState({
      user: profile,
      certificateFiles: certificateFiles.map((item) => {
        const updating = currentCertificateFiles.find(
          (old) =>
            old.counter === item.counter && this.state.updatingData.indexOf(item.counter) > -1
        );
        if (updating) {
          return updating;
        }
        return item;
      })
    });
  };

  saveData = (cb, cbProgress, file) => {
    const id = 'update';
    const handleSuccess = (error, data, success) => {
      let certificateFiles = data?.certificateFiles?.certificateFiles || data?.certificateFiles;

      if (success && Array.isArray(certificateFiles)) {
        certificateFiles = JSON.parse(JSON.stringify(certificateFiles));

        this.setState({
          user: {
            ...this.state.user,
            certificateFiles
          },
          certificateFiles
        });
      }

      cb && cb(error, data, success);
    };

    if (cbProgress) {
      this.upload(
        id,
        {
          file,
          data: [
            {
              fieldname: 'file',
              title: this.state.title,
              promotionYear: this.state.promotionYear,
              specialty: this.state.specialty
            }
          ]
        },
        cbProgress,
        handleSuccess
      );
    } else {
      this.api(
        id,
        {
          certificateFiles: this.state.certificateFiles
        },
        handleSuccess
      );
    }
  };

  remove = (item, cb) => {
    this.api(
      'update',
      {
        certificateFiles: (this.state.certificateFiles || []).filter(
          (c) => c.counter !== item.counter
        )
      },
      (error, data, success) => {
        let certificateFiles = data?.certificateFiles?.certificateFiles || data?.certificateFiles;

        if (success && Array.isArray(certificateFiles)) {
          certificateFiles = JSON.parse(JSON.stringify(certificateFiles));

          this.setState({
            user: {
              ...this.state.user,
              certificateFiles
            },
            certificateFiles
          });
        }

        cb && cb(error, data, success);
      }
    );
  };

  validateSave = (cb) => {
    const id = 'update';
    const { title, promotionYear, specialty } = this.state;

    let invalid = validateObj(
      {
        title,
        promotionYear,
        specialty
      },
      {
        title: 'certificateTitle',
        promotionYear: 'promotionYear',
        specialty: 'specialty'
      }
    );

    this.requests[id] = this.initialApiState();
    this.requests[id].loading = false;
    this.requests[id].invalid = invalid;
    this.invalid = invalid;
    if (invalid.length === 0) {
      cb();
    } else {
      this.trigger();
    }
  };

  resetForm = () => {
    this.setState({
      title: '',
      promotionYear: '',
      specialty: ''
    });
  };
}

const model = new CertificateModel();
export default model;
